import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Card, SectionTitle } from "../../../common";
import { colors, spacing, typography } from "../../../../theme/tokens";
import servicesData from "../../../sections/services.json";

const { services } = servicesData;

const LAB_WORKS = services.filter((service) => service.track === "開発室");

function Lab() {
  return (
    <Box id="lab" sx={{ scrollMarginTop: { xs: "72px", md: "100px" } }}>
      <Container
        maxWidth="lg"
        sx={{ py: { xs: 8, md: 12 }, px: { xs: "16px", md: "10vw" } }}
      >
        <SectionTitle en="LAB" ja="開発室" />
        <Grid container spacing={4} sx={{ mt: spacing[400] }}>
          {LAB_WORKS.map((work) => (
            <Grid item xs={12} sm={6} md={4} key={work.title}>
              <Box
                component="a"
                href={work.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "block",
                  textDecoration: "none",
                  height: "100%",
                }}
              >
                <Card
                  interactive
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      height: "180px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: colors.neutral[50],
                      borderBottom: `1px solid ${colors.neutral[200]}`,
                    }}
                  >
                    <img
                      src={work.logo}
                      alt={work.title}
                      style={{
                        maxHeight: "140px",
                        maxWidth: "70%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <Box sx={{ p: spacing[600], flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: typography.fontWeight.bold }}
                    >
                      {work.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: spacing[200],
                        color: colors.neutral[600],
                        lineHeight: typography.lineHeight.relaxed,
                      }}
                    >
                      {work.description}
                    </Typography>
                  </Box>
                </Card>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Lab;
